var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Solution"},[_c('Part1'),_c('Part2'),_c('Part8'),_c('Part3'),_c('Part4'),_c('Part5'),_c('Part6'),_c('Part7')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }